import React from "react";
import { connect } from "react-redux";
import { BranchContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAdd } from "react-icons/md";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import { Buttons, Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class BranchContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_BRANCH_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.BRANCH}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.BRANCH}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "branch");
    return (
      <BranchContainerStyled>
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
          </div>
        )}
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </BranchContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "name",
      length: "311px",
      filter: {
        fieldQuery: "name",
        defaultValue: initialValues["name"],
        type: "text",
        label: "Branch search",
        placeholder: "Branch name",
      },
    },
  ];
};

const columns = ({ handleClickDetail }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Branch</div>,
    accessor: "name",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Province</div>,
    accessor: "province",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>District</div>,
    accessor: "district",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Sub district</div>,
    accessor: "sub_district",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Zipcode</div>,
    accessor: "zipcode",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BranchContainer));
